// extracted by mini-css-extract-plugin
export default {"mainContainer":"bj_fV","contentViewport":"bj_fW"};